<template lang="pug">
	#notes.custom-container
		.section-title Notas
		b-breadcrumb.breadcrumb(:items="breadcrumbs")
		ListNote
</template>

<script>
import ListNote from '../components/notes/ListNote'

export default {
	components: {
		ListNote
	},
	data () {
		return {
			breadcrumbs: [
				{
					text: 'Inicio',
					to: { name: 'Home' }
				},
				{
					text: 'Notas',
					active: true
				}
			]
		}
  }
}
</script>
